export default __webpack_public_path__ + "static/media/director.5d82b3b9.jpg";